import React from "react";
import { Link } from "react-router-dom";
import ceLogo from "../../assets/images/ce-logo.png";
import { FiMail, FiPhone, FiMapPin, FiLinkedin } from "../../assets/icons/vander";

export default function FooterSeven() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: "AI/ML Solutions", link: "/services/data-aiml" },
      { name: "Cloud Services", link: "/services/cloud" },
    ],
    solutions: [
      { name: "Omniscientia AI", link: "https://omniscientia.codeelan.com/" },
      { name: "Perfectus", link: "https://perfectus.codeelan.com/" },
      { name: "Case Studies", link: "/case-studies" },
    ],
    company: [
      { name: "About Us", link: "/aboutus" },
      { name: "Mission and Vision", link: "/aboutus" },
      { name: "Partnerships", link: "/aboutus/partnership" },
      { name: "Careers", link: "/careers" },
      { name: "Contact", link: "/contactus" },
    ],
    legal: [
      { name: "Privacy Policy", link: "/page-privacy_policy" },
      { name: "Code of Conduct", link: "/page-code_of_conduct" },
    ],
  };

  // Only LinkedIn social link
  const socialLinks = [
    { icon: FiLinkedin, link: "https://www.linkedin.com/company/codeelan-technologies/", label: "LinkedIn" },
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
      <div className="container">
        <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="footer-company">
                <img src={ceLogo} alt="CodeElan" className="footer-logo mb-3" height="40" />
                <p className="footer-description">
                  Empowering businesses with cutting-edge AI/ML solutions, computer vision technology, 
                  and comprehensive testing automation to drive innovation and efficiency.
                </p>
                <div className="footer-social">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.link}
                      className="social-link"
                      aria-label={social.label}
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                      <social.icon />
                    </a>
                  ))}
                </div>
              </div>
                </div>

            {/* Services */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="footer-links">
                <h5 className="footer-title">Services</h5>
                <ul className="footer-list">
                  {footerLinks.services.map((link, index) => (
                    <li key={index}>
                      <Link to={link.link} className="footer-link">
                        {link.name}
                          </Link>
                        </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Solutions */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="footer-links">
                <h5 className="footer-title">Solutions</h5>
                <ul className="footer-list">
                  {footerLinks.solutions.map((link, index) => (
                    <li key={index}>
                      <a href={link.link} className="footer-link" target="_blank" rel="noopener noreferrer">
                        {link.name}
                      </a>
                        </li>
                  ))}
                      </ul>
                    </div>
                  </div>

            {/* Company */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="footer-links">
                <h5 className="footer-title">Company</h5>
                <ul className="footer-list">
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <Link to={link.link} className="footer-link">
                        {link.name}
                          </Link>
                        </li>
                  ))}
                      </ul>
                    </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="footer-contact">
                <h5 className="footer-title">Contact</h5>
                <div className="contact-info">
                  <div className="contact-item">
                    <FiMail className="contact-icon" />
                    <span>info@codeelan.com</span>
                  </div>
                  <div className="contact-item">
                    <FiPhone className="contact-icon" />
                    <span>+91-8208650598</span>
                  </div>
                  <div className="contact-item">
                    <FiMapPin className="contact-icon" />
                    <span>India</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright">
                © {currentYear} CodeElan Technologies. All rights reserved.
              </p>
            </div>
            <div className="col-md-6">
              <div className="footer-legal">
                {footerLinks.legal.map((link, index) => (
                  <Link key={index} to={link.link} className="legal-link">
                    {link.name}
                      </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
